import { useState, useCallback } from "react";
import axiosInstance from "../axiosInstance";
import { getCurrentUser } from "../components/Guest/services/authService";

export const useCommitteeReview = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);

  const createReview = useCallback(async ({ requestProgressId, review, rejectionReason, onSuccess }) => {
    setIsProcessing(true);
    setError(null);
    try {
      const user = await getCurrentUser();
      if (!user) {
        throw new Error("User not found");
      }
      const member_id = user.id;

      const requestBody = {
        review,
        request_progress_id: +requestProgressId,
        member_id: +member_id,
      };

      // Add rejection reason if review is rejected
      if (review === "rejected" && rejectionReason) {
        requestBody.rejection_reason = rejectionReason;
      }

      const response = await axiosInstance.post("/api/committee-reviews/enduser", requestBody);

      if (response.status === 201 || response.status === 200) {
        onSuccess();
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsProcessing(false);
    }
  }, []);

  const getReviews = useCallback(async ({ requestProgressId, persona }) => {
    setIsProcessing(true);
    setError(null);
    try {
      const endpoint = persona === "customer" 
        ? `/api/committee-reviews/enduser/${requestProgressId}`
        : `/api/committee-reviews/request_progress_id/${requestProgressId}`;
      
      const response = await axiosInstance.get(endpoint);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsProcessing(false);
    }
  }, []);

  return { createReview, getReviews, isProcessing, error };
};
